import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authState: {
      token: localStorage.getItem('token-user') || '',
      loggedUser: JSON.parse(localStorage.getItem('logged-user')) || '',
    },
    settings: {},
    purchase: JSON.parse(localStorage.getItem('purchase')) || '',
    commingVideochat: null
  },
  getters: {
    isAuthenticated: state => !!state.authState.token,
    loggedUser: state => state.authState.loggedUser,
    settings: state => state.settings,
    purchase: state => state.purchase,
    commingVideochat: state => state.commingVideochat,
  },
  mutations: {
    authSuccess(state, {token, loggedUser} ) {
      state.authState.token = token;
      state.authState.loggedUser = loggedUser;
    },
    updateLoggedUserData(state, {loggedUser} ) {
      state.authState.loggedUser = loggedUser;
      localStorage.setItem('logged-user', JSON.stringify(loggedUser));
    },
    logout(state) {
      state.authState.token = '';
      state.authState.loggedUser = {};
      localStorage.removeItem('logged-user');
      localStorage.removeItem('token-user');
    },
    storeSettings(state,settings){
      state.settings = settings;
    },
    storePurchase(state,purchase){
      localStorage.setItem('purchase', JSON.stringify(purchase));
      state.purchase = purchase;
    },
    removePurchase(state){
      localStorage.removeItem('purchase');
      state.purchase = {};
    },
    setCommingVideochat(state, commingVideochat ) {
      state.commingVideochat = commingVideochat;
    },
  },
  actions: {
    
  }
})